import { SelectOption } from '@globaleris/ui.library'
import { LanguageModel } from '../../../../../api/Argentia/model/contracts'
import { ProductTranslationModel } from './translationsCard.model'

export const getUnusedTranslations = (
  productTranslations: ProductTranslationModel[],
  languages: LanguageModel[],
  row?: any
): SelectOption[] => {
  // Take all the used translations from component Prop 'translations'
  const usedTranslations = productTranslations.map(t => {
    return {
      value: t.language,
      label: t.description
    }
  })

  // Filter unused languages from FetchLanguages
  const unusedLanguages = languages.filter(l => {
    return (
      !usedTranslations.some(t => {
        return t.value === l.id ? true : false
      }) || l.id === row?.language
    )
  })

  // Transform LanguageModel to SelectOption
  const unusedTranslations = unusedLanguages.map(l => {
    return {
      value: l.id,
      label: l.description
    }
  })

  return unusedTranslations
}
